const RECOLLECTION_BASE_URL = '/recollection/'

const RECOLLECTION_SIGN_IN_URL = `${RECOLLECTION_BASE_URL}:partnerName/sign-in`

const RECOLLECTION_DOCS_REUPLOAD_URL = `${RECOLLECTION_BASE_URL}documents`

const RECOLLECTION_SUCCESS_URL = `${RECOLLECTION_BASE_URL}success`
const RECOLLECTION_NOT_FOUND_URL = `${RECOLLECTION_BASE_URL}not-found`
const RECOLLECTION_LOGGED_OUT_URL = `${RECOLLECTION_BASE_URL}logged-out`
const RECOLLECTION_PARTNER_DISABLED_URL = `${RECOLLECTION_BASE_URL}partner-disabled`

export const RECOLLECTION_ROUTES = {
  BASE_URL: RECOLLECTION_BASE_URL,

  SIGN_IN_URL: RECOLLECTION_SIGN_IN_URL,

  DOCS_REUPLOAD_URL: RECOLLECTION_DOCS_REUPLOAD_URL,

  SUCCESS_URL: RECOLLECTION_SUCCESS_URL,
  NOT_FOUND_URL: RECOLLECTION_NOT_FOUND_URL,
  LOGGED_OUT_URL: RECOLLECTION_LOGGED_OUT_URL,
  PARTNER_DISABLED_URL: RECOLLECTION_PARTNER_DISABLED_URL,
}

const ONBOARDING_BASE_URL = '/onboarding/'

const ONBOARDING_SIGN_IN_URL = `${ONBOARDING_BASE_URL}:partnerName/sign-in`
const ONBOARDING_CONTINUE_SIGN_IN_URL = `${ONBOARDING_BASE_URL}:partnerName/continue-sign-in`
const ONBOARDING_SIGN_UP_URL = `${ONBOARDING_BASE_URL}:partnerName/sign-up`
const ONBOARDING_ENTER_CODE_URL = `${ONBOARDING_BASE_URL}:partnerName/enter-code`
const ONBOARDING_SIGN_IN_WITH_TOKEN_URL = `${ONBOARDING_BASE_URL}sign-in-with-token`

const ONBOARDING_HOME_URL = `${ONBOARDING_BASE_URL}home`
const ONBOARDING_DOCS_URL = `${ONBOARDING_BASE_URL}docs`

const ONBOARDING_SUCCESS_URL = `${ONBOARDING_BASE_URL}success`
const ONBOARDING_NOT_FOUND_URL = `${ONBOARDING_BASE_URL}not-found`
const ONBOARDING_LOGGED_OUT_URL = `${ONBOARDING_BASE_URL}logged-out`
const ONBOARDING_PARTNER_DISABLED_URL = `${ONBOARDING_BASE_URL}partner-disabled`
const ONBOARDING_ALREADY_REGISTERED_URL = `${ONBOARDING_BASE_URL}already-registered`

export const ONBOARDING_ROUTES = {
  BASE_URL: ONBOARDING_BASE_URL,

  SIGN_IN_URL: ONBOARDING_SIGN_IN_URL,
  CONTINUE_SIGN_IN_URL: ONBOARDING_CONTINUE_SIGN_IN_URL,
  SIGN_UP_URL: ONBOARDING_SIGN_UP_URL,
  ENTER_CODE_URL: ONBOARDING_ENTER_CODE_URL,
  SIGN_IN_WITH_TOKEN_URL: ONBOARDING_SIGN_IN_WITH_TOKEN_URL,

  HOME_URL: ONBOARDING_HOME_URL,
  DOCS_URL: ONBOARDING_DOCS_URL,
  ALREADY_REGISTERED_URL: ONBOARDING_ALREADY_REGISTERED_URL,

  SUCCESS_URL: ONBOARDING_SUCCESS_URL,
  NOT_FOUND_URL: ONBOARDING_NOT_FOUND_URL,
  LOGGED_OUT_URL: ONBOARDING_LOGGED_OUT_URL,
  PARTNER_DISABLED_URL: ONBOARDING_PARTNER_DISABLED_URL,
}

const CLIENT_BASE_URL = '/client/'

const CLIENT_SIGN_IN_URL = `${CLIENT_BASE_URL}:partnerName/sign-in`
const CLIENT_CONTINUE_SIGN_IN_URL = `${CLIENT_BASE_URL}:partnerName/continue-sign-in`
const CLIENT_SIGN_UP_URL = `${CLIENT_BASE_URL}:partnerName/sign-up`
const CLIENT_ENTER_CODE_URL = `${CLIENT_BASE_URL}:partnerName/enter-code`
const CLIENT_SIGN_IN_WITH_TOKEN_URL = `${CLIENT_BASE_URL}sign-in-with-token`

const CLIENT_HOME_URL = `${CLIENT_BASE_URL}home`
const CLIENT_DOCS_URL = `${CLIENT_BASE_URL}documents`

const CLIENT_SUCCESS_URL = `${CLIENT_BASE_URL}success`
const CLIENT_NOT_FOUND_URL = `${CLIENT_BASE_URL}not-found`
const CLIENT_LOGGED_OUT_URL = `${CLIENT_BASE_URL}logged-out`
const CLIENT_PARTNER_DISABLED_URL = `${CLIENT_BASE_URL}partner-disabled`
const CLIENT_ALREADY_REGISTERED_URL = `${CLIENT_BASE_URL}already-registered`

export const CLIENT_ROUTES = {
  BASE_URL: CLIENT_BASE_URL,

  SIGN_IN_URL: CLIENT_SIGN_IN_URL,
  CONTINUE_SIGN_IN_URL: CLIENT_CONTINUE_SIGN_IN_URL,
  SIGN_UP_URL: CLIENT_SIGN_UP_URL,
  ENTER_CODE_URL: CLIENT_ENTER_CODE_URL,
  SIGN_IN_WITH_TOKEN_URL: CLIENT_SIGN_IN_WITH_TOKEN_URL,

  HOME_URL: CLIENT_HOME_URL,
  DOCS_URL: CLIENT_DOCS_URL,
  ALREADY_REGISTERED_URL: CLIENT_ALREADY_REGISTERED_URL,

  SUCCESS_URL: CLIENT_SUCCESS_URL,
  NOT_FOUND_URL: CLIENT_NOT_FOUND_URL,
  LOGGED_OUT_URL: CLIENT_LOGGED_OUT_URL,
  PARTNER_DISABLED_URL: CLIENT_PARTNER_DISABLED_URL,
}

const CONTRACTOR_PORTAL_BASE_URL = '/contractor/'

const CONTRACTOR_PORTAL_SIGN_IN_URL = `${CONTRACTOR_PORTAL_BASE_URL}sign-in`
const CONTRACTOR_PORTAL_SELECT_PARTNER_URL = `${CONTRACTOR_PORTAL_BASE_URL}select-partner`
const CONTRACTOR_PORTAL_ENTER_CODE_URL = `${CONTRACTOR_PORTAL_BASE_URL}enter-code`

const CONTRACTOR_PORTAL_HOME_URL = `${CONTRACTOR_PORTAL_BASE_URL}home`
const CONTRACTOR_PORTAL_INVOICES_URL = `${CONTRACTOR_PORTAL_BASE_URL}invoices`
const CONTRACTOR_PORTAL_DOCUMENTS_URL = `${CONTRACTOR_PORTAL_BASE_URL}documents`
const CONTRACTOR_PORTAL_CERTIFICATES_URL = `${CONTRACTOR_PORTAL_BASE_URL}certificates`
const CONTRACTOR_PORTAL_PAYMENT_URL = `${CONTRACTOR_PORTAL_BASE_URL}payment`
const CONTRACTOR_PORTAL_CONTACT_DETAILS_URL = `${CONTRACTOR_PORTAL_BASE_URL}contact-details`

const CONTRACTOR_PORTAL_SUCCESS_URL = `${CONTRACTOR_PORTAL_BASE_URL}success`
const CONTRACTOR_PORTAL_NOT_FOUND_URL = `${CONTRACTOR_PORTAL_BASE_URL}not-found`
const CONTRACTOR_PORTAL_LOGGED_OUT_URL = `${CONTRACTOR_PORTAL_BASE_URL}logged-out`
const CONTRACTOR_PORTAL_PARTNER_DISABLED_URL = `${CONTRACTOR_PORTAL_BASE_URL}partner-disabled`

export const CONTRACTOR_PORTAL_ROUTES = {
  BASE_URL: CONTRACTOR_PORTAL_BASE_URL,

  SIGN_IN_URL: CONTRACTOR_PORTAL_SIGN_IN_URL,
  SELECT_PARTNER_URL: CONTRACTOR_PORTAL_SELECT_PARTNER_URL,
  ENTER_CODE_URL: CONTRACTOR_PORTAL_ENTER_CODE_URL,

  HOME_URL: CONTRACTOR_PORTAL_HOME_URL,
  INVOICES_URL: CONTRACTOR_PORTAL_INVOICES_URL,
  DOCUMENT_URL: CONTRACTOR_PORTAL_DOCUMENTS_URL,
  CERTIFICATES_URL: CONTRACTOR_PORTAL_CERTIFICATES_URL,
  PAYMENT_URL: CONTRACTOR_PORTAL_PAYMENT_URL,
  CONTACT_DETAILS_URL: CONTRACTOR_PORTAL_CONTACT_DETAILS_URL,

  SUCCESS_URL: CONTRACTOR_PORTAL_SUCCESS_URL,
  NOT_FOUND_URL: CONTRACTOR_PORTAL_NOT_FOUND_URL,
  LOGGED_OUT_URL: CONTRACTOR_PORTAL_LOGGED_OUT_URL,
  PARTNER_DISABLED_URL: CONTRACTOR_PORTAL_PARTNER_DISABLED_URL,
}

const PRE_CLIENT_BASE_URL = '/pre-onboarding/'

const PRE_CLIENT_SELECT_CITY_URL = `${PRE_CLIENT_BASE_URL}:partnerName/select-city`

export const PRE_CLIENT_ROUTES = {
  SELECT_CITY_URL: PRE_CLIENT_SELECT_CITY_URL,
}

const OPPORTUNITY_BASE_URL = '/opportunity/'

const OPPORTUNITY_APPLY_URL = `${OPPORTUNITY_BASE_URL}:publicToken`

export const OPPORTUNITY_ROUTES = {
  BASE_URL: OPPORTUNITY_BASE_URL,
  APPLY_URL: OPPORTUNITY_APPLY_URL,
}
